import ActivitiesRegistrationDetails from './ActivitiesRegistrationDetails';

export default ActivitiesRegistrationDetails;